import { render, staticRenderFns } from "./social-items.vue?vue&type=template&id=33891d6d&"
import script from "./social-items.vue?vue&type=script&lang=js&"
export * from "./social-items.vue?vue&type=script&lang=js&"
import style0 from "./social-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports